import { css } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import { Select } from 'antd';
import { useAdjustSalesStatus } from 'hooks/business/chat/useChatHeader';
import { useConversationReadonlyValue } from 'hooks/business/conversation';

interface LightAdjustSalesStatusProps {
  conversation: Conversation.Conversation;
}

export const LightAdjustSalesStatus = (props: LightAdjustSalesStatusProps) => {
  const { conversation } = props;
  const readonly = useConversationReadonlyValue();
  const { t } = useTranslate();

  const { salesStatus, changeSalesStatus } = useAdjustSalesStatus(conversation);

  const options = [
    { value: 'BEFORE_SALES_STATUS', label: t('aide.售前') },
    { value: 'DURING_SALES_STATUS', label: t('aide.售中') },
    { value: 'AFTER_SALES_STATUS', label: t('aide.售后') },
  ];

  return (
    <Select
      className={containerClassName}
      disabled={readonly}
      value={salesStatus}
      onChange={changeSalesStatus}
      optionLabelProp="label"
      dropdownMatchSelectWidth={false}
      options={options}
      size="small"
    />
  );
};

const containerClassName = css`
  .ant-select-selector {
    height: 20px !important;
    border: none !important;
    padding-left: 0.5rem !important;
    padding-right: 0 !important;
  }

  .ant-select-selection-item {
    line-height: 20px !important;
    color: #515359 !important;
    padding-right: 22px !important;
  }

  .ant-select-arrow {
    font-size: 10px !important;
    width: 10px !important;
    height: 10px !important;
    color: #515359 !important;
    margin-top: -5px !important;
    right: 8px !important;
  }
`;
